import { ColorDepthEffect } from 'postprocessing'
import { wrapEffect } from '../util'

export const ColorDepth = wrapEffect(ColorDepthEffect)
